module.exports = __webpack_public_path__ + "static/media/009-rain-26.a776a801.svg";